// extracted by css-extract-rspack-plugin
export default {"cookie_consent":"styles-module__cookie_consent--_ir0i"};